// extracted by mini-css-extract-plugin
export default {"SectionTitle":"yunyigou-order-detail_SectionTitle__H2gGR","SectionSubTitle":"yunyigou-order-detail_SectionSubTitle__JwBYQ","Toolbar":"yunyigou-order-detail_Toolbar__feE4B"};